import _ from 'underscore'
import JSX, { Component } from 'preact'
import axios, { AxiosResponse } from 'axios'
import { isFunction } from '../../libs/preact-entry'

interface Props {
  baseUrl: string,
  searchValue: string,
  onLoaded: Function,
  children: JSX.Element,
  responseKey?: string
}

interface State {
  loading: boolean,
  items: []
}

export default class Fetch extends Component<Props, State> {
  mounted = false

  constructor () {
    super()
    this.state = {
      loading: false,
      items: []
    }
  }

  fetch = _.debounce(() => {
    if (!this.mounted) return

    const { baseUrl, searchValue, onLoaded, responseKey } = this.props
    const url = `${baseUrl}${searchValue}`

    axios.get(url).then((response: AxiosResponse) => {
      const items = responseKey ? response.data[responseKey] : response.data
      if (this.mounted) {
        onLoaded(items)
        this.setState({ loading: false, items })
      }
    })
  }, 300)

  prepareFetch () {
    this.setState({ ...this.state, loading: true })
  }

  componentDidMount () {
    this.mounted = true
    this.prepareFetch()
    this.fetch()
  }

  componentDidUpdate (prevProps: Props) {
    if (prevProps.searchValue !== this.props.searchValue) {
      this.prepareFetch()
      this.fetch()
    }
  }

  componentWillUnmount () {
    this.mounted = false
  }

  render (props: Props, state: State) {
    if (isFunction(props.children[0])) {
      return props.children[0](state)
    }
    return null
  }
}
